<template>
  <div>
    <nav
      class="navigationBar navbar fixed-top navbar-expand-lg navbar-dark bg-dark static-top"
    >
      <div class="container-fluid">
        <router-link
          class="navbar-brand"
          :to="navItems[0].name"
          href="#"
          v-on:click="scrollToHash(navItems[0].name)"
        >
          <img
            src="@/assets/images/logo.png"
            class="img-responsive"
            alt="Erbe company logo"
          />
        </router-link>
        <button
          id="navbar-toggler-btn"
          v-on:click="clickedToggleBtn"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto align-items-center">
            <!-- Menu Items -->
            <li class="nav-item" v-for="item in navItems" :key="item.name">
              <router-link
                class="nav-link"
                href="#"
                :to="item.name"
                :class="`${item.desktopOnly ? 'instrumentsAndAcc' : ''}`"
                v-on:click="scrollToHash(item.name)"
                >{{ $t(item.textKey) }}
              </router-link>
            </li>
            <li v-if="shouldShowOfflineAppUrl" class="nav-item">
              <a :href="offlineAppUrl" class="nav-link">{{
                $t("menu_item_offlineapp")
              }}</a>
            </li>
            <!-- Settings -->
            <li class="nav-item" v-if="shouldShowSettings">
              <a class="nav-link" v-on:click="openModal">{{
                $t("menu_item_settings")
              }}</a>
            </li>
            <!-- Language Switch -->
            <li
              class="nav-item language-switch"
              v-on:click="checkIfElementsForThisLanguageAreCached"
            >
              <router-link :to="`/${displayedLanguage}`" class="nav-link"
                >{{ displayedLanguage }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <SettingsModal v-if="isSettingsModalopen"/>
  </div>
</template>

<script>
import SettingsModal from "@/components/Settings/Modal";
import { languageAdapter } from "@/services/languageAdapter";
import { useToast } from "vue-toastification";
import ToastComponent from "@/components/ToastComponent";

const allowedLanguages = ["de", "en"];

export default {
  name: "NavigationBar",
  components: { SettingsModal},
  setup() {
      const toast = useToast();
      return { toast }
    },
  data() {
    return {
      navItems: [
        {
          name: "home",
          textKey: "nav_home"
        },
        {
          name: "ies3",
          textKey: "nav_ies3"
        },
        {
          name: "instrumente",
          textKey: "nav_instruments_acc",
          desktopOnly: true
        },
        {
          name: "weltweit",
          textKey: "nav_world"
        },
        {
          name: "contact",
          textKey: "nav_contact"
        },
        {
          name: "downloads",
          textKey: "nav_downloads"
        }
      ]
    };
  },
  computed: {
    currentLanguage() {
      return languageAdapter.getLanguageOfUserFromPath(this.$route.params);
    },
    displayedLanguage() {
      return this.currentLanguage === allowedLanguages[0]
        ? allowedLanguages[1]
        : allowedLanguages[0];
    },
    shouldShowOfflineAppUrl() {
      const { supportsPWAandFetch, isPwaModeActive } = this.$store.state;
      if (isPwaModeActive) {
        return false;
      }
      if (!supportsPWAandFetch) {
        return false;
      }
      if (!this.offlineAppUrl) {
        return false;
      }
      return true;
    },
    shouldShowSettings() {
      const { supportsPWAandFetch, isPwaModeActive } = this.$store.state;
      if (isPwaModeActive && supportsPWAandFetch) {
        return true;
      }
      return false;
    },
    offlineAppUrl() {
      if (process.env.VUE_APP_OFFLINE_URL) {
        const parts = process.env.VUE_APP_OFFLINE_URL.split("?");
        if (parts.length === 2) {
          return parts[0] + `#/${this.currentLanguage}?` + parts[1];
        }
      }
      return process.env.VUE_APP_OFFLINE_URL;
    },
    isSettingsModalopen() {
    return this.$store.state.isSettingsModalopen;
  },
  },
  mounted() {
    document.addEventListener("swRegistered", this.setDownloadPossible);
  },
  beforeUnmount() {
    document.removeEventListener("swRegistered", this.setDownloadPossible);
  },
  methods: {
    openModal() {
      this.$store.commit("setIsSettingsModalopen", true);
    },
    setDownloadPossible() {
      this.downloadsPossible = true;
    },
    clickedToggleBtn() {
      this.isDropdownVisibil = !this.isDropdownVisibil;
    },
    scrollToHash(name) {
      document.getElementById(name).scrollIntoView();
      const isInCompactMode = window.innerWidth <= 992;
      if (isInCompactMode) {
        document.getElementById("navbar-toggler-btn").click();
      }
    },
    checkIfElementsForThisLanguageAreCached() {
      if (
        !this.$store.getters.isLanguageCached(
          languageAdapter.getLanguageOfUserFromPath(this.$route.params)
        ) &&
        this.$store.state.isPwaModeActive &&
        this.$store.state.wasOfflineModeInitialized === "true"
      ) {
        this.toast({
          component: ToastComponent,
          props: {
              text: this.$t("files_arent_cached_for_selected_languageToast"),
              action: () => {
                  this.$store.commit("setIsSettingsModalopen", true);
                },
              actionName: this.$t("open_settings"),   
              closeText: this.$t("close"),
            },

            }, { containerClassName: "my-container-class", toastClassName: "my-custom-toast-class", bodyClassName: ["custom-class-1"], })
      }
    }
  }
};
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}
.nav-link:hover {
  transform: scale(1.05);
}
@media (min-width: 992px) {
  .language-switch {
    display: flex;
    align-items: center;
  }
  .language-switch::before {
    content: " | ";
    color: rgba(255, 255, 255, 0.5);
  }
}
@media (max-width: 767px) {
  .instrumentsAndAcc {
    display: none;
  }
}
</style>
